<template>
  <div id="wrapper">
    <navbar></navbar>

    <div class="container-fluid">
      <child></child>
    </div>

    <template v-if="authCheck">
      <br>

      <footer>
        <div class="text-center">
          <p>&copy; Todos los Derechos Reservados, {{ company }} {{ year }}</p>
          <br />
        </div>
      </footer>
    </template>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'

import Navbar from '~/components/Navbar'
import Child from '~/components/Child'

export default {
  name: 'default-layout',
  components: {
    'navbar': Navbar,
    'child': Child,
  },
  computed: mapGetters({
    authCheck: 'authCheck',
  }),
  data: () => ({
    company: window.config.company,
    copyright: window.config.copyright,
    appName: window.config.appName,
    year: window.config.year,
    appEnv: window.config.appEnv,
    locale: window.config.locale,
  }),
}
</script>
